export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.triggerId = item != null ? item.triggerId : ''
        this.vendorname = item != null ? item.vendorname : '' 
        this.kvK = item != null ? item.kvK : ''
        this.iban = item != null ? item.iban : ''
        this.vatNumber = item != null ? item.vatNumber : ''
        this.regexFactuurnummer = item != null ? item.regexFactuurnummer : ''
        this.regexFactuurdatum = item != null ? item.regexFactuurdatum : ''
        this.regexReferentie = item != null ? item.regexReferentie : ''
        this.regexTotaalbedrag = item != null ? item.regexTotaalbedrag : ''
        this.regexKostenHoog = item != null ? item.regexKostenHoog : ''
        this.regexKostenLaag = item != null ? item.regexKostenLaag : ''
        this.regexKostenNul = item != null ? item.regexKostenNul : ''
        this.regexKostenVerlegd = item != null ? item.regexKostenVerlegd : ''
        this.regexBtwHoog = item != null ? item.regexBtwHoog : ''
        this.regexBtwLaag = item != null ? item.regexBtwLaag : ''
        this.testcontent = item != null ? item.testcontent : ''
        this.testfilename = item != null ? item.testfilename : ''
    }
}